import { render, staticRenderFns } from "./whiteWood.vue?vue&type=template&id=7c69aff8"
import script from "./whiteWood.vue?vue&type=script&lang=js"
export * from "./whiteWood.vue?vue&type=script&lang=js"
import style0 from "./whiteWood.vue?vue&type=style&index=0&id=7c69aff8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports